import type { ActionOutput } from '@occ/contracts';
import { post } from '../api/http';
import { ROUTES } from '../api/routes';
import { runAction } from './actions';

/**
 * Sesiones de soporte activas (RF-09, Módulo 8).
 *
 * `sessions.listActive` es del catálogo y el backend ya la resuelve. Cerrar una
 * sesión ajena **todavía no tiene ruta para el operador**: existe
 * `POST /internal/terminal/sessions/:id/close`, pero va con el token interno del
 * gateway, no con el JWT de un humano, y darle acceso al panel sería regalarle
 * una credencial de servicio. La pantalla intenta `POST /sessions/:id/close` y
 * explica el 404 en vez de tragárselo.
 */

export type ActiveSession = ActionOutput<'sessions.listActive'>['sessions'][number];

export const listActiveSessions = async (): Promise<ActiveSession[]> => {
  const { sessions } = await runAction('sessions.listActive', {});
  return [...sessions].sort((left, right) => right.startedAt.getTime() - left.startedAt.getTime());
};

export const closeSession = async (sessionId: string): Promise<void> => {
  await post<unknown>(ROUTES.closeSession(sessionId));
};
